export default function Section16() {
    const processSteps = [
        {
            title: "Discovery & Strategy",
            description:
                "Understand your business, audience, and goals.",
        },
        {
            title: "Design & Prototyping",
            description:
                "Create wireframes and prototypes to test user experience.",
        },
        {
            title: "Development & Integration",
            description:
                "Build using the latest technology.",
        },
        {
            title: "QA & Testing",
            description:
                "Check across devices and browsers for flawless performance.",
        },
        {
            title: "Launch & Optimization",
            description:
                "Deploy and continuously monitor your website.",
        },
        {
            title: "Ongoing Support & Growth",
            description:
                "Updates, maintenance, and scaling as your business grows.",
        },
    ];

    return (
        <div className="Section16 py-[80px] md:py-[100px] bg-[white]">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our Process for the Best <span className="text-[#DA2128]">Website Development</span>
                </h2>
                <h3 className="mt-6 text-[#DA2128] text-[18px] md:text-[20px] font-semibold max-w-[600px] mx-auto">
                    A Transparent Process, From Discovery to Launch
                </h3>
                <p className="mt-2 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    We follow a clear step-by-step process to deliver your website on time and exceed expectations.
                </p>
            </div>

            {/* Process Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {processSteps.map((step, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition ${index % 2 === 0
                                ? "bg-[#E42E35] text-white" // red card
                                : "bg-white text-[#151515]" // normal white card
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {step.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>

            {/* CTA Button */}
            <div className="text-center mt-12">
                <a
                    href="https://mean3.com/contact-mean3"
                    className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
                >
                    Learn About Our Process
                </a>
            </div>
        </div>
    );
}
